import {
    getShipToOfScInforUrl,
    getCmgtOfSkuInforUrl,
    batchAddShoppingCartUrl,
    cartCountUrl
} from 'Utils/urlUtil'
import { callApi, get } from 'Utils/apiUtil'

export const GET_SHIPTO_OF_SC_INFOR = 'GET_SHIPTO_OF_SC_INFOR';
export const GET_CMGT_SKU_INFOR = 'GET_CMGT_SKU_INFOR';
export const BATCH_ADD_SHOPPING_CART = 'BATCH_ADD_SHOPPING_CART';

//get shipTo info
export function getShipToOfScInfor(stNumber) {
    const url = `${getShipToOfScInforUrl}?shipTo=${stNumber}`
    const options = {
        method: 'GET',
    }
    const request = () => ({ type: GET_SHIPTO_OF_SC_INFOR, payload: { shipToInforOfApplyChange: {} } })
    const success = (response) => {
        return { type: GET_SHIPTO_OF_SC_INFOR, payload: { shipToInforOfApplyChange: response } }
    }
    const failure = () => ({ type: GET_SHIPTO_OF_SC_INFOR, payload: { shipToInforOfApplyChange: {} } })

    return callApi(url, options, request, success, failure)
}

export function getCmgtOfSkuInfor(sku, shipTo) {
    const url = `${getCmgtOfSkuInforUrl}?skuCode=${sku}&shipTo=${shipTo}`
    const options = {
        method: 'GET',
    }
    const request = () => ({ type: GET_CMGT_SKU_INFOR, payload: { cmgtOfSkuInfor: {} } })
    const success = (response) => {
        return { type: GET_CMGT_SKU_INFOR, payload: { cmgtOfSkuInfor: response } }
    }
    const failure = () => ({ type: GET_CMGT_SKU_INFOR, payload: { cmgtOfSkuInfor: {} } })

    return callApi(url, options, request, success, failure)
}

// export const batchAddCart = (params) => {

//     const request = null

//     const options = {
//         data: params
//     }

//     const success = (response) => ({ type: BATCH_ADD_SHOPPING_CART, payload: { ...response } })
//     const failure = null

//     return callApi(batchAddShoppingCartUrl, options, request, success, failure)
// };

export const getAddBatchCartCount = (email) => {
    return dispatch => dispatch(get(cartCountUrl, { email }))
        .then(res => {
            dispatch({ type: BATCH_ADD_SHOPPING_CART, payload: res });
        });
};